module.exports = __webpack_public_path__ + "img/IMG_8969.179a9261.jpg";